/**
 * LEADS objective — Search campaigns that turn searches into enquiries (calls,
 * WhatsApp, forms, optionally a Google lead form). Pages in this folder:
 * LeadsPage (workspace list), LeadsCampaignWizard, CreateLeadsAdgroup, CreateLeadsAd.
 */
import { Users } from 'lucide-react';
import { SearchObjectiveConfig } from '@/components/google-ads/search/searchShared';

export const LEADS_BASE = '/google-ads/leads';

export const LEADS_OBJECTIVE: SearchObjectiveConfig = {
  key: 'leads',
  title: 'Leads',
  base: LEADS_BASE,
  subtitle: 'Search ads that turn searches into enquiries — calls, WhatsApp, forms and bookings',
  icon: Users,
  leadForms: true,
  // The wizard moves this to Maximize conversions once Google confirms the account tracks conversions.
  defaultBidding: 'MAXIMIZE_CLICKS',
  goal: 'Calls, forms & WhatsApp enquiries',
  emptyHint: 'Show up when people search for what you offer, and turn those searches into calls, WhatsApp chats and form fills.',
};
